var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStaarEye = function SvgStaarEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.188 10.808c-1.551-2.17-3.744-4.102-6.52-5.744C43.145 1.8 35.852 0 28.12 0 20.392 0 13.097 1.8 7.577 5.064c-2.775 1.642-4.972 3.574-6.524 5.744C.657 11.364.308 11.928 0 12.5h4.143c.49 0 .957-.205 1.28-.562 1.122-1.237 2.578-2.397 4.337-3.44 4.873-2.88 11.393-4.466 18.36-4.466 6.967 0 13.49 1.586 18.361 4.467 1.86 1.099 3.374 2.328 4.518 3.647a.53.53 0 0 1 0 .707c-1.144 1.32-2.658 2.547-4.518 3.646a31.079 31.079 0 0 1-5.753 2.667c1.387-1.92 2.28-4.2 2.484-6.666H39.01c-.56 4.76-4.762 8.467-9.845 8.467-5.08 0-9.281-3.708-9.844-8.467h-4.198C15.7 19.487 21.776 25.038 29.165 25c7.295-.036 13.98-1.798 19.503-5.063 2.776-1.64 4.969-3.577 6.52-5.747.204-.282.395-.57.575-.859a1.581 1.581 0 0 0 0-1.665c-.18-.287-.37-.573-.575-.858Z",
    fill: "#fff"
  })));
};
export default SvgStaarEye;